<script setup lang="ts">
import i18n from '@/lang/i18n';
import { GDialog } from 'gitart-vue-dialog'
import { computed } from "vue"

const emits = defineEmits(['update:modelValue', 'confirm', 'cancel'])

const props = defineProps<{
  modelValue: boolean,
}>()

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits('update:modelValue', value);
  },
})

function confirm() {
  emits('confirm')
}

function closeModal() {
  emits('cancel')
}

</script>

<template>
  <GDialog
    v-model="modelValue"
    max-width="50%"
    transition="custom-from-bottom-transition"
    :persistent='true'
  >
    <div class="modal-header justify-content-center mt-2">
      <label :class="props.titleClass">
        {{ i18n.global.t('pages.dailyReports.ignoreLongtimeContinuousWarning.confirmModalTitle') }}
      </label>
    </div>

    <div class="modal-body mx-4">
      <div :class="props.noteClass">
        {{ i18n.global.t('pages.dailyReports.ignoreLongtimeContinuousWarning.confirmModalBody') }}
      </div>
    </div>

    <div class="d-flex justify-content-end m-3 mt-4">
      <v-btn class="ma-2 reset-btn" @click="closeModal">
        {{i18n.global.t('common.backBtn')}}
      </v-btn>
      <v-btn
        class="ma-2 exec-btn"
        :class="props.confirmBtnClass"
        @click="confirm"
        :loading="loading"
      >
        {{ i18n.global.t('common.confirmBtn') }}
      </v-btn>
    </div>
  </GDialog>
</template>

<style scope>
</style>
